<template>
  <div class="validate-email">
    <div class="card loader">
        <loader></loader>
    </div>
  </div>
</template>

<script>
import config from '../config';
import Loader from './Loader.vue';

export default {
    name: 'ValidateEmail',
    
    data () {
        return {
        }
    },
    components: {
        Loader
    },
    methods: {
        validate() {
            this.loading = true;
            
            const token = this.$route.params.token;

            fetch(config.api + '/auth/validate/' + token, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({})
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.json();
            })
            .then(() => {
                this.notificationController.addNotification({ type: 'success', title: 'E-mail validated', message: 'Email validated successfully, you can login now.', duration: 5000 });
                
                this.$router.push('/login');
            })
            .catch(error => {
                this.notificationController.addNotification({ type: 'error', title: 'Validation error', message: 'Something went wrong, please try again.', duration: 5000 });
                console.log(error);
                this.$router.push('/login');
            })
            .finally(() => {
                this.loading = false;
            });
        }
    },
    created() {
        this.validate();
    }
}
</script>

<style scoped>

.validate-email {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
}

h2 {
    text-align: center;
}

.card {
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.loader {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 240px;
}



</style>


// WEBPACK FOOTER //
// src/components/ValidateEmail.vue